import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Modal from 'react-modal';
import NotificationsView from '../../classes/notifications';
import AlternativeIdentityXHR from '../../classes/identity';
import PathManagement from '../../common/path-management';
import { history } from '../../common/history';
import MobileMenu from './mobile-menu.js';
import HeaderCart from './header-cart.js';
import Search from './search.js';
import Notifications from './notifications.js';
import ClientServices from './client-services.js';
import { routes, registerRoute } from '../../common/constants';
import AngoliaBuscador from './angolia';

function Header(props) {
  const [MobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [ModalIsOpen, setModalIsOpen] = useState(false);
  const [emailAlternative, setEmailAlternative] = useState('');
  const [showModal, setShowModal] = useState(false);
  const _pathManager = new PathManagement();
  const imgURL = _pathManager.getImgURL();

  let location = useLocation();

  //Setea si el menu mobile está abierto o cerrado
  const toggleMobileMenuOpen = () => {
    if (MobileMenuOpen) {
      setMobileMenuOpen(false);
    } else {
      setMobileMenuOpen(true);
    }
  };
  //Cierra el menu mobile
  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  function afterOpenModal() {
    // references are now sync'd and can be accessed.
    subtitle.style.color = '#f00';
  }

  function closeModal() {
    setModalIsOpen(false);
  }

  function openModal() {
    setModalIsOpen(true);
  }

  let subtitle;
  const customStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      backgroundColor: 'none',
      border: '0px',
    },
  };

  const ROLES_ENABLED = ['admin_gral', 'admin_int'];

  const changeToAlternativeIdentity = async () => {
    if (emailAlternative && emailAlternative.length > 0) {
      let _alternativeIdentityXHR = new AlternativeIdentityXHR();
      let _data = await _alternativeIdentityXHR.getAlternativeIdentity(emailAlternative);
      if (_data.statusCode == 200) {
        window.location.reload(false);
      } else {
        // toast.error
      }
    }
  };

  const getBackIdentity = async () => {
    let _alternativeIdentityXHR = new AlternativeIdentityXHR();
    let _data = await _alternativeIdentityXHR.getBackIdentity();
    if (_data.statusCode == 200) {
      window.location.reload(false);
    } else {
      // toast.error
    }
  };

  const showGetBackIdentity = () => {
    if (props.loggedInData) {
      if (
        props.loggedInData.usuarioCarga &&
        props.loggedInData.usuarioCarga.us_id != props.loggedInData.us_id
      ) {
        return true;
      }
    }
    return false;
  };

  const keyDownSearch = (e) => {
    if (e.keyCode === 13) {
      changeToAlternativeIdentity();
    }
  };

  const goToLogin = () => {
    if (!props.username) {
      // location.replace(routes.login);
      history.push(routes.login);
    }
  };

  const goToRegister = () => {
    if (!props.username) {
      // location.replace(registerRoute);
      history.push(registerRoute);
    }
  };

  const formatPrice = (priceString) => {
    if (priceString) {
      let trimmedPrice = priceString.replace('$', '').trim();

      let price = parseFloat(trimmedPrice).toLocaleString('es-AR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });

      return `$ ${price}`;
    }
  };

  //Devuelve el total del carrito en el header

  const cartSubtotal = () => {
    if (props.cartItems && props.cartItems.products.length > 0) {
      return (
        <div>
          <div className="text-right">
            <p className="text-gray-dark py-2 mb-0">
              <span className="text-muted">Subtotal:</span> &nbsp;
              {props.cartItems.subtotal == '-'
                ? props.cartItems.subtotal
                : formatPrice(props.cartItems.subtotal)}
            </p>
          </div>
          <div className="d-flex">
            <div className="pr-2 w-50">
              <Link className="btn btn-secondary btn-sm btn-block mb-0" to="/carrito">
                <i className="icon-shopping-cart mr-2"></i>
                Ver Carrito
              </Link>
            </div>
            <div className="pl-2 w-50">
              <Link className="btn btn-primary btn-sm btn-block mb-0" to="/checkout">
                <i className="icon-check-circle mr-2"></i>
                Confirmar
              </Link>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div>
          <span>No tenés productos en el carrito</span>
        </div>
      );
    }
  };

  return (
    <>
    <div style={{ height: '15px', backgroundColor: '#1d81aa' }}></div>
    <div className="topbar d-flex justify-content-between" style={{ maxWidth: '1364px', margin: 'auto' }}>
      {/* Logo*/}
      <div className="site-branding d-flex" onClick={closeMobileMenu}>
        <a className="site-logo align-self-center" href="/">
          <img src="./img/logo/logo-planetoffice.svg" title="comprar insumos oficina" alt="PlanetOffice" />
        </a>
      </div>
      {/* Search / Categories*/}
      <div className="search-box-wrap d-flex">
        <div className="search-box-inner align-self-center">
          <div className="search-box d-flex">
            <div className="btn-group categories-btn">
              <button className="btn btn-secondary dropdown-toggle" data-toggle="dropdown">
                <i className="icon-menu text-lg" />
                &nbsp;Categorías
              </button>
              <div className="dropdown-menu mega-dropdown">
                <div className="row">
                  <Link className="col no-under" to="/productLane/00000002">
                    <>
                      <p className="d-block navi-link text-center mb-30" href="shop-grid-ls.html">
                        <img alt="papel" className="d-block" title='Comprar papel' src="img/categories/papel.png" />
                        <span className="text-gray-dark">Papel</span>
                      </p>
                    </>
                  </Link>
                  <Link className="col no-under" to="/productLane/00000001">
                    <>
                      <p className="d-block navi-link text-center mb-30" href="shop-grid-ls.html">
                        <img
                          alt="escritura"
                          title="comprar productos escritura, boligrafos, lapiceras"
                          className="d-block"
                          src="img/categories/escritura.png" />
                        <span className="text-gray-dark">Escritura</span>
                      </p>
                    </>
                  </Link>
                  <Link className="col no-under" to="/BuscadorInsumos">
                    <>
                      <p className="d-block navi-link text-center mb-30" href="shop-grid-ls.html">
                        <img
                          alt="toner y cartuchos"
                          className="d-block"
                          src="img/categories/toner_y_cartuchos.png"
                          title='comprar toners y cartuchos' />
                        <span className="text-gray-dark">Toner y Cartuchos</span>
                      </p>
                    </>
                  </Link>
                  <Link className="col no-under" to="/productLane/00000003">
                    <>
                      <p className="d-block navi-link text-center mb-30" href="shop-grid-ls.html">
                        <img alt="informática" className="d-block" title='comprar productos informatica, ofimatica' src="img/categories/informatica.png" />
                        <span className="text-gray-dark">Informática</span>
                      </p>
                    </>
                  </Link>
                  <Link className="col no-under" to="/productLane/00000005">
                    <>
                      <p className="d-block navi-link text-center mb-30" href="shop-grid-ls.html">
                        <img alt="básicos" className="d-block" title='comprar básicos oficina' src="img/categories/basicos.png" />
                        <span className="text-gray-dark">Básicos</span>
                      </p>
                    </>
                  </Link>
                </div>
                <div className="row">
                  <Link className="col no-under" to="/productLane/00000006">
                    <>
                      <p className="d-block navi-link text-center mb-30" href="shop-grid-ls.html">
                        <img alt="archivo" className="d-block" title='comprar archivos' src="img/categories/archivo.png" />
                        <span className="text-gray-dark">Archivo</span>
                      </p>
                    </>
                  </Link>
                  <Link className="col no-under" to="/productLane/00000009">
                    <>
                      <p className="d-block navi-link text-center mb-30" href="shop-grid-ls.html">
                        <img alt="presentacion" className="d-block" title='comprar pizarra' src="img/categories/presentacion.png" />
                        <span className="text-gray-dark">Presentación</span>
                      </p>
                    </>
                  </Link>
                  <Link className="col no-under" to="/productLane/00000008">
                    <>
                      <p className="d-block navi-link text-center mb-30" href="shop-grid-ls.html">
                        <img alt="electrónicos" className="d-block" title='comprar electronicos' src="img/categories/electronicos.png" />
                        <span className="text-gray-dark">Electrónicos</span>
                      </p>
                    </>
                  </Link>
                  <Link className="col no-under" to="/productLane/00000007">
                    <>
                      <p className="d-block navi-link text-center mb-30" href="shop-grid-ls.html">
                        <img alt="cafetería" className="d-block" title='comprar productos cafeteria' src="img/categories/cafeteria.png" />
                        <span className="text-gray-dark">Cafetería</span>
                      </p>
                    </>
                  </Link>
                  <Link className="col no-under" to="/productLane/PlanetPlus">
                    <>
                      <p className="d-block navi-link text-center mb-30" href="shop-grid-ls.html">
                        <img alt="planetplus" className="d-block" title='productos planet plus' src="img/categories/planetplus.png" />
                        <span className="text-gray-dark">PlanetPlus</span>
                      </p>
                    </>
                  </Link>
                </div>
              </div>
            </div>
            <AngoliaBuscador></AngoliaBuscador>
            {/* <Search></Search> */}
          </div>
        </div>
      </div>
      {/* Toolbar*/}
      <div className="toolbar d-flex">
        <div
          onClick={toggleMobileMenuOpen}
          className={`toolbar-item visible-on-mobile mobile-menu-toggle ${MobileMenuOpen ? ' active' : ''}`}
        >
          <a href="#">
            <div>
              <i className={`icon-menu ${MobileMenuOpen ? ' icon-x' : ''}`} />
              <span className="text-label">Menu</span>
            </div>
          </a>
        </div>
        {props.loggedInData ? (
          <div className="toolbar-item hidden-on-mobile">
            <Link to={props.username ? '/notificacioneslist' : null}>
              <div>
                <span className="cart-icon">
                  <i className="icon-bell"></i>
                  <span className="count-label">
                    {props.NotificationsQty > 10 ? '+10' : props.NotificationsQty}{' '}
                  </span>
                </span>
                <span className="text-label">Notificaciones</span>
              </div>
            </Link>

            <Notifications
              NotificationsMsg={props.NotificationsMsg}
              getNotifications={props.getNotifications} />
            {/* <Search/> */}
          </div>
        ) : null}
        {/* <div className="toolbar-item hidden-on-mobile">
      <Link to="/userInfo/wishlist">
        <div>
          <span className="compare-icon">
            <i className="icon-heart" />
            <span className="count-label">{props.WishlistItems ? props.WishlistItems.length : 0} </span>
          </span>
          <span className="text-label">Favoritos</span>
        </div>
      </Link>
    </div> */}
        <ClientServices />

        <div className="toolbar-item hidden-on-mobile">
          <Link to={props.username ? '/userInfo/detail' : '/login'} onClick={() => goToLogin()}>
            <div>
              <i className="icon-user" />
              <span className="text-label">
                {props.username ? props.username : 'Iniciar sesión / Registrarse'}
              </span>
            </div>
          </Link>

          <div className="toolbar-dropdown text-center px-3 ddown-mi-cuenta">
            {props.username ? null : (
              <p className="text-xs mb-3 pt-2">
                Iniciá sesión en tu cuenta o registrate en una nueva para tener control de tus pedidos,
                recibir beneficios y más.
              </p>
            )}
            {props.username ? (
              <Link to="/home/loggedIn" className="no-href-deco">
                <div className="row px-3">
                  <p className="mt-2 mb-2  no-href-deco">
                    <i className="icon-home mr-2"></i>Inicio
                  </p>
                </div>
              </Link>
            ) : null}
            {props.username ? (
              <Link to="/userInfo/detail" className="no-href-deco">
                <div className="row px-3">
                  <p className="mt-2 mb-2  no-href-deco">
                    <i className="icon-user mr-2"></i>Mi cuenta
                  </p>
                </div>
              </Link>
            ) : null}
            {props.username ? (
              <Link to="/userInfo/wishlist" className="no-href-deco">
                <div className="row px-3">
                  <p className="mt-2 mb-2 no-href-deco">
                    <i className="icon-heart mr-2"></i>Favoritos
                  </p>
                </div>
              </Link>
            ) : null}
            {props.username ? (
              <Link to="/userInfo/frequent" className="no-href-deco">
                <div className="row px-3">
                  <p className="mt-2 mb-2">
                    <i className="icon-clock mr-2"></i>
                    Frecuentes
                  </p>
                </div>
              </Link>
            ) : null}
            {props.username ? (
              <Link to="/userInfo/orders" className="no-href-deco">
                <div className="row px-3">
                  <p className="mt-2 mb-2  no-href-deco">
                    <i className="icon-shopping-bag mr-2"></i>Mis compras
                  </p>
                </div>
              </Link>
            ) : null}
            {/* {props.username ? (
      <Link to="/userInfo/orders/wishlist" className="no-href-deco">
        <div className="row px-3">
          <p className="mt-2 mb-2  no-href-deco">
            <i className="icon-star mr-2"></i>Mis compras favoritas
          </p>
        </div>
      </Link>
    ) : null} */}
            <Link
              className="btn btn-primary btn-sm btn-block"
              to={props.username ? '/' : '/login'}
              onClick={() => {
                if (props.username) props.handleLogout();
                else goToLogin();
              } }
            >
              <i>
                <span className={` ${props.username ? 'icon-log-out mr-2' : 'icon-log-in mr-2'}`}></span>
              </i>
              {props.username ? 'Salir' : 'Iniciar sesión'}
            </Link>
            {props.username ? null : (
              <p className="text-xs text-muted mb-2">
                {props.username ? null : 'Cliente nuevo?'}&nbsp;
                <Link onClick={() => goToRegister()} to="/register">
                  {props.username ? null : 'Registrate'}
                </Link>
              </p>
            )}
            {showGetBackIdentity() ? (
              <p className="text-left alternative-identity" onClick={getBackIdentity}>
                <i className="icon-log-in mr-2 "></i>Retomar identidad
              </p>
            ) : null}
            {props.loggedInData &&
              props.loggedInData.usuarioRol &&
              ROLES_ENABLED.includes(props.loggedInData.usuarioRol.ur_clave) ? (
              <>
                <p
                  className="text-left alternative-identity"
                  onClick={() => {
                    setShowModal(true);
                  } }
                >
                  <i className="icon-user mr-2 text-left "></i>Identidad alternativa
                </p>

                <Modal
                  isOpen={showModal}
                  onRequestClose={() => {
                    setShowModal(false);
                  } }
                  style={customStyles}
                  contentLabel="Example Modal"
                >
                  <div className="modal-content">
                    <div className="modal-body">
                      <label htmlFor="emailAlternative">Ingresá el nombre de usuario substituto:</label>
                      <input
                        type="text"
                        placeholder="ejemplo@mail.com"
                        className="form-control"
                        value={emailAlternative}
                        name="emailAlternative"
                        onChange={(e) => {
                          setEmailAlternative(e.target.value);
                        } }
                        onKeyDown={keyDownSearch}
                      ></input>
                    </div>
                    <div className="modal-footer">
                      <button
                        onClick={() => {
                          setShowModal(false);
                        } }
                        className="btn btn-outline-secondary btn-sm"
                        type="button"
                      >
                        Cancelar
                      </button>
                      <button
                        onClick={() => {
                          changeToAlternativeIdentity();
                        } }
                        className="btn btn-primary btn-sm"
                        type="button"
                        data-dismiss="modal"
                      >
                        Aceptar
                      </button>
                    </div>
                  </div>
                </Modal>
              </>
            ) : null}{' '}
          </div>
          {/* <div className="toolbar-dropdown text-center px-3">
      <p className="text-xs mb-3 pt-2">
        {props.username
          ? 'Si queres salir hacé click aquí debajo.'
          : 'Iniciá sesión en tu cuenta o registrate en una nueva para tener control de tus pedidos, recibir beneficios y más.'}
      </p>
      <Link
        className="btn btn-primary btn-sm btn-block"
        to={props.username ? '/' : '/login'}
        onClick={props.username ? props.handleLogout : null}
      >
        {props.username ? 'Salir' : 'Iniciar sesión'}
      </Link>
      {props.loggedInData &&
        props.loggedInData.usuarioRol &&
        (parseInt(props.loggedInData.us_nivel) >= 3  ||
          props.loggedInData.usuarioRol.ur_nombre === 'Vendedor') && (
          <Link
            className="red"
            to=""
            onClick={() => {
              openModal();
            }}
          >
            <span>
              <i className="icon-users"></i>&nbsp;Identitdad alternativa
            </span>
          </Link>
        )}
      <p className="text-xs text-muted mb-2">
        {props.username ? null : 'cliente nuevo?'}&nbsp;
        <Link to="/login">{props.username ? null : 'Registrate'}</Link>
      </p>
    </div>  */}
        </div>
        <Modal
          isOpen={ModalIsOpen}
          onAfterOpen={afterOpenModal}
          onRequestClose={closeModal}
          style={customStyles}
          contentLabel="Example Modal"
        >
          <h3 ref={(_subtitle) => (subtitle = _subtitle)}>Ingrese el nombre de usuario sustituto</h3>
          <div className="column">
            <form className="coupon-form" method="POST">
              <input
                type="text"
                placeholder="Usuario sustituto"
                className="alternative-user form-control form-control-sm"
              ></input>
              <button onClick={closeModal} className="btn btn-outline-primary btn-sm ">
                Aceptar
              </button>
            </form>
          </div>
          <i
            onClick={(e) => {
              closeModal();
            } }
            className="icon-x modal-close"
          ></i>
        </Modal>
        <div onClick={closeMobileMenu} className="toolbar-item">
          <Link to="/carrito">
            <div>
              <span className="cart-icon">
                <i className="icon-shopping-cart" />
                <span className="count-label">{props.cartItems ? props.cartItems.products.length : 0} </span>
              </span>
              <span className="text-label">Carrito</span>
            </div>
          </Link>
          <div
            className="toolbar-dropdown cart-dropdown widget-cart hidden-on-mobile"
            style={{ width: '450px' }}
          >
            <HeaderCart cartItems={props.cartItems} deleteCartItem={props.deleteCartItem} />
            {cartSubtotal()}
          </div>
        </div>
      </div>
      {/* ACA VA EL MOBILE MENU */}
    </div>
      <MobileMenu
        MobileMenuOpen={MobileMenuOpen}
        toggleMobileMenuOpen={toggleMobileMenuOpen}
        closeMobileMenu={closeMobileMenu}
        username={props.username}
        handleLogout={props.handleLogout}
        wishlistItems={props.WishlistItems}
        NotificationsMsg={props.NotificationsMsg}
        getNotifications={props.getNotifications} />
    </>
  );
}

export default Header;
